import { writable } from "svelte/store";
export const initVal = {
    duration: 0.25,
    attendeeCount: 0,
    salaries: [],
    screen: "CALCULATOR",
    displayShareModal: false,
};
export const calcStore = writable(initVal);
